"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFRESH_WINDOW = exports.UPDATE_CENTER_SIZE = exports.CHANGE_WINDOW_MODIFIED = exports.UPDATE_CLIENT_SIZES = exports.PIN_TOGGLE_STACK_PANEL = exports.HIDE_STACK_PANEL = exports.BEFORE_CLOSE_WINDOW = exports.ASYNC_ACTIVE_WINDOW_CHANGED_AFTER = exports.ASYNC_ACTIVE_WINDOW_CHANGED = exports.WINDOW_CONTENT_LOAD = exports.VISIBLE_STACK_CHANGED = exports.ACTIVE_WINDOW_CHANGED = exports.RESIZE_WINDOW = exports.CLOSE_WINDOW = exports.UPDATE_WINDOW = exports.OPEN_WINDOW = void 0;
exports.OPEN_WINDOW = 'DOCKER.OPEN_WINDOW';
exports.UPDATE_WINDOW = 'DOCKER.UPDATE_WINDOW';
exports.CLOSE_WINDOW = 'DOCKER.CLOSE_WINDOW';
exports.RESIZE_WINDOW = 'DOCKER.RESIZE_WINDOW';
exports.ACTIVE_WINDOW_CHANGED = 'DOCKER.ACTIVE_WINDOW_CHANGED';
exports.VISIBLE_STACK_CHANGED = 'DOCKER.VISIBLE_STACK_CHANGED';
exports.WINDOW_CONTENT_LOAD = 'DOCKER.WINDOW_CONTENT_LOAD';
exports.ASYNC_ACTIVE_WINDOW_CHANGED = 'DOCKER.ASYNC_ACTIVE_WINDOW_CHANGED';
exports.ASYNC_ACTIVE_WINDOW_CHANGED_AFTER = 'DOCKER.ASYNC_ACTIVE_WINDOW_CHANGED_AFTER';
exports.BEFORE_CLOSE_WINDOW = 'DOCKER.BEFORE_CLOSE_WINDOW';
exports.HIDE_STACK_PANEL = 'DOCKER.HIDE_STACK_PANEL';
exports.PIN_TOGGLE_STACK_PANEL = 'DOCKER.PIN_TOGGLE_STACK_PANEL';
exports.UPDATE_CLIENT_SIZES = 'DOCKER.UPDATE_CLIENT_SIZES';
exports.CHANGE_WINDOW_MODIFIED = 'DOCKER.CHANGE_WINDOW_MODIFIED';
exports.UPDATE_CENTER_SIZE = 'DOCKER.UPDATE_CENTER_SIZE';
exports.REFRESH_WINDOW = 'DOCKER.SAGA_REFRESH_WINDOW';
//# sourceMappingURL=actionTypes.js.map